
const matrixDataAr = [
    [
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "two",
            content : null,
            icon : null,
        },
        {
            type : "two",
            content : null,
            icon : null,
        },
        {
            type : "three",
            content : "حماية خصوصية العميل",
            icon : "social.svg",
        },
        {
            type : "three",
            content : null,
            icon : null,
        },
        {
            type : "three",
            content : null,
            icon : null,
        },
        {
            type : "three",
            content : null,
            icon : null,
        },
        {
            type : "three",
            content : "الالتزام برؤية المملكة 2030",
            icon : "governance.svg",
        },
        
    ],
    [
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "two",
            content : null,
            icon : null,
        },
        {
            type : "two",
            content : "إطار عمل الحوكمة",
            icon : "governance.svg",
        },
        {
            type : "three",
            content : null,
            icon : null,
        },
        {
            type : "three",
            content : "أخلاق مهنية",
            icon : "governance.svg",
        },
        {
            type : "three",
            content : null,
            icon : null,
        },
        {
            type : "three",
            content : null,
            icon : null,
        },
        
    ],
    [
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "two",
            content : null,
            icon : null,
        },
        {
            type : "two",
            content : "التوظيف",
            icon : "social.svg",
        },
        {
            type : "three",
            content : "المجتمعات المحلية",
            icon : "social.svg",
        },
        {
            type : "three",
            content : null,
            icon : null,
        },
        {
            type : "three",
            content : "الأداءالاقتصادي",
            icon : "economic.svg",
        },
        
    ],
    [
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "two",
            content : null,
            icon : null,
        },
        {
            type : "two",
            content : "التّنوع",
            icon : "social.svg",
        },
        {
            type : "three",
            content : "التمويل المستدام",
            icon : "environment.svg",
        },
        {
            type : "three",
            content : null,
            icon : null,
        },
        
    ],
    [
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : "التقييم الاجتماعي للموردين",
            icon : "social.svg",
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : "التأثيرات الاقتصادية غير المباشرة",
            icon : "economic.svg",
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "two",
            content : null,
            icon : null,
        },
        {
            type : "two",
            content : null,
            icon : null,
        },
        {
            type : "three",
            content : null,
            icon : null,
        },
        
    ],
    [
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "two",
            content : "الانبعاثات",
            icon : "environment.svg",
        },
        {
            type : "two",
            content : null,
            icon : null,
        },
        
    ],
    [
        {
            type : "one",
            content : "تأثيرات التنوع البيولوجي",
            icon : "environment.svg",
        },
        {
            type : "one",
            content : "ممارسات المشتريات",
            icon : "economic.svg",
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : "إدارة المخلفات",
            icon : "environment.svg",
        },
        {
            type : "one",
            content : "التدريب والتعليم",
            icon : "social.svg",
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : "استهلاك الماء",
            icon : "environment.svg",
        },
        {
            type : "two",
            content : null,
            icon : null,
        },
        
    ],
    [
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : "الصحة والسلامة المهنية",
            icon : "social.svg",
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        
    ],
]

export default matrixDataAr;